export default "__VITE_ASSET__CtyUUo9t__"